// src/app/desktop.routes.ts
import { Routes } from '@angular/router';
import { AccessRightEnum } from '@boshared';
import { accessRightGuardConfig } from '../core/guard/access-right.guard';
import { LayoutBasicComponent } from '../layout';
import { ProfileComponent } from './user-setting/profile-setting/profile.component';
import { profileResolver } from './user-setting/profile-setting/services/profile.resolver';

export const desktopRoutes: Routes = [
  {
    path: '', // This path is relative to where desktopRoutes is loaded
    component: LayoutBasicComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'farms',
        loadChildren: () => import('./farms/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'logbooks',
        loadChildren: () => import('./logbooks/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'iotDevice',
        loadChildren: () => import('./iot-device/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'irrigation',
        loadChildren: () => import('./irrigation/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'inventory',
        loadChildren: () => import('./inventory/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'worker',
        loadChildren: () => import('./worker/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'task',
        loadChildren: () => import('./task/routes').then(m => m.routes)
      },
      {
        path: 'flight',
        loadChildren: () => import('./flight/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'harvest',
        loadChildren: () => import('./harvest/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'userSettings',
        loadChildren: () => import('./user-setting/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'operationTool',
        loadChildren: () => import('./user-setting/operation-tool/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'web/profile/:id',
        component: ProfileComponent,
        resolve: { editData: profileResolver },
        data: { title: 'Profile', titleI18n: 'app.userSettings_accountSetting.profile.title' }
      }
    ]
  }
];
